
export function contarAprobados(calificaciones, materiasValidas, minAprobado = 6) {
  const resultado = {};
  console.log("Materias válidas: " + materiasValidas);

  Object.entries(calificaciones).forEach(([codigo, valor]) => {
    const match = codigo.match(/^[a-zA-Z]+/);
    const materiaId = match ? match[0] : codigo;

    if (!materiasValidas.includes(materiaId)) return;

    const nota = parseInt(valor.split("@@")[0], 10);

    if (!resultado[materiaId]) {
      resultado[materiaId] = { total: 0, completed: 0 };
    }

    resultado[materiaId].total += 1;
    if (!isNaN(nota) && nota >= minAprobado) {
      resultado[materiaId].completed += 1;
    }
  });

  return resultado;
}

export function contarProgresoCurso(calificaciones, temasCurso, minAprobado = 7) {
  const resultado = { total: 0, completed: 0 };

  temasCurso.forEach((codigo) => {
    const valor = calificaciones[codigo];
    if (!valor) return; // el alumno no tiene calificación para este tema

    const nota = parseInt(valor.split("@@")[0], 10); // soporta formato "nota@@fecha@@otro"
    resultado.total += 1;
    if (!isNaN(nota) && nota >= minAprobado) {
      resultado.completed += 1;
    }
  });

  return resultado;
}

